"use client";
import { useQuery } from "@tanstack/react-query";
import { getHeroServices } from "@/lib/actions/admin-dashboard/hero-services/get/getHeroServices";

export const useGetHeroServices = () => {
  return useQuery({
    queryKey: ["hero-services"],
    queryFn: getHeroServices,
  });
};